import { captureException } from "@sentry/react";
import { Dispatch } from "redux";
import { AxiosInstance } from "axios";
import { showNotification } from "../../notification/actions";
import { REMOVE_TASK } from "../types";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";

export default (data: { planId: string, index: number }) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<{ success: boolean, playable: boolean }>("/remove-task", data);
        dispatch({
            type: REMOVE_TASK,
            payload: { ...res, ...data },
        });
        return true;
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
        return false;
    }
};